module.exports = __webpack_public_path__ + "img/wx.d7566aa2.png";